import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unsave-changes',
  templateUrl: './unsave-changes.component.html',
  styleUrls: ['./unsave-changes.component.scss']
})
export class UnsaveChangesComponent {
  constructor(public dialogRef: MatDialogRef<UnsaveChangesComponent>,

  ) { }
}
